import AsyncStorage from "@react-native-async-storage/async-storage";
import React from "react";
import { Pressable, ScrollView, Text, TouchableOpacity } from "react-native";
import { View } from "react-native";
import i18n from "../util/i18n";
import { CommonActions } from '@react-navigation/native';
import { Button, Stack } from "@mui/material";

class AdminLayout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: ''
        }
    }

    componentDidMount() {
        this.setActivePage();
    }

    setActivePage = () => {
        // get the curreent page name
        let pageName = this.props.children.type.name;
        // set the current page name in state
        this.setState({ activePage: pageName });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.children.type.name != this.props.children.type.name) {
            this.setActivePage();
        }
    }

  render() {
    return (
        <View style={{ flex: 1, flexDirection: 'row' }}>
            {/* Left Sidebar */}
            <View style={{ flexDirection: 'column', backgroundColor: 'lightgray', padding: 10, minWidth: 200 }}>
                {/* Logo */}
                <Stack spacing={2} alignItems="center" style={{ flex: 1 }}>
                    <Button
                        fullWidth
                        variant={this.state.activePage == 'Home' ? 'contained' : 'outlined'}
                        onClick={() => {
                            this.props.navigation.navigate('Home')
                        }}
                    >
                        {i18n.t('home')}
                    </Button>
                    <Button
                        fullWidth
                        variant={this.state.activePage == 'Points' ? 'contained' : 'outlined'}
                        onClick={() => {
                            this.props.navigation.navigate('Points')
                        }}
                    >
                        {i18n.t('points')}
                    </Button>
                    <Button
                        fullWidth
                        variant={this.state.activePage == 'Answers' ? 'contained' : 'outlined'}
                        onClick={() => {
                            this.props.navigation.navigate('Answers')
                        }}
                    >
                        {i18n.t('answers')}
                    </Button>
                    <Button
                        fullWidth
                        variant={this.state.activePage == 'Categories' ? 'contained' : 'outlined'}
                        onClick={() => {
                            this.props.navigation.navigate('Categories')
                        }}
                    >
                        {i18n.t('categories')} / {i18n.t('songs')}
                    </Button>
                    <Button
                        fullWidth
                        variant={this.state.activePage == 'Settings' ? 'contained' : 'outlined'}
                        onClick={() => {
                            this.props.navigation.navigate('Settings')
                        }}
                    >
                        {i18n.t('settings')}
                    </Button>
                    <Button
                        fullWidth
                        variant={this.state.activePage == 'Dislpay' ? 'contained' : 'outlined'}
                        onClick={() => {
                            this.props.navigation.navigate('Display')
                        }}
                    >
                        {i18n.t('display')}
                    </Button>
                </Stack>
                <View>
                    <Button
                        fullWidth
                        color="error"
                        variant="contained"
                        onClick={() => {
                            // clear passKey from local storage
                            AsyncStorage.removeItem('passKey');
                            AsyncStorage.removeItem('token');
                            // redirect to login page
                            this.props.navigation.replace('Login')
                        }}
                    >
                        {i18n.t('logout')}
                    </Button>
                </View>
            </View>
            <ScrollView style={{ padding: 10, flexGrow: 1 }}>
                {this.props.children}
            </ScrollView>
        </View>
    );
  }
}

const styles = {
    activeButton: {
        backgroundColor: 'blue',
        padding: 10,
        borderRadius: 5,
        marginVertical: 10,
        alignItems: 'center'
    },
    activeButtonText: {
        color: 'white'
    },
    button: {
        borderColor: 'blue',
        borderWidth: 1,
        padding: 10,
        borderRadius: 5,
        marginVertical: 10,
        alignItems: 'center'
    },
    buttonText: {
        color: 'blue'
    }
}

export default AdminLayout;
